export default "__VITE_ASSET__DurqjNeN__"